function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Legend");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("ellipse", {
  id: "path-1",
  cx: 52.5,
  cy: 52,
  rx: 52.5,
  ry: 52
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Legend",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("text", {
  id: "Trend-indicator-Copy-2",
  fontFamily: "IBMPlexSans-Text, IBM Plex Sans",
  fontSize: 12,
  fontWeight: 500,
  fill: "#434D7E"
}, React.createElement("tspan", {
  x: 173,
  y: 20
}, "Trend "), React.createElement("tspan", {
  x: 173,
  y: 35
}, "indicator")), React.createElement("text", {
  id: "Group-name-Copy",
  fontFamily: "IBMPlexSans-Text, IBM Plex Sans",
  fontSize: 12,
  fontWeight: 500,
  fill: "#434D7E"
}, React.createElement("tspan", {
  x: 173,
  y: 103
}, "Group "), React.createElement("tspan", {
  x: 173,
  y: 118
}, "name")), React.createElement("text", {
  id: "Number-of-messages-Copy-2",
  fontFamily: "IBMPlexSans-Text, IBM Plex Sans",
  fontSize: 12,
  fontWeight: 500,
  fill: "#434D7E"
}, React.createElement("tspan", {
  x: 6,
  y: 112
}, "Number of "), React.createElement("tspan", {
  x: 6,
  y: 127
}, "messages")), React.createElement("text", {
  id: "Average-Group-KCI-Copy",
  fontFamily: "IBMPlexSans-Text, IBM Plex Sans",
  fontSize: 12,
  fontWeight: 500,
  fill: "#434D7E"
}, React.createElement("tspan", {
  x: 3,
  y: 14
}, "Average"), React.createElement("tspan", {
  x: 3,
  y: 29
}, "Group KCI")), React.createElement("g", {
  id: "Group-31-Copy",
  transform: "translate(61.000000, 11.000000)"
}, React.createElement("g", {
  id: "Oval-5-Copy-9",
  stroke: "#B3CAE6"
}, React.createElement("ellipse", {
  strokeWidth: 1,
  cx: 52.5,
  cy: 52,
  rx: 53,
  ry: 52.5
}), React.createElement("ellipse", {
  strokeOpacity: 0.23938519,
  strokeWidth: 5,
  strokeLinejoin: "square",
  cx: 52.5,
  cy: 52,
  rx: 50,
  ry: 49.5
})), React.createElement("g", {
  id: "Group-Copy-3",
  transform: "translate(34.000000, 30.000000)"
}, React.createElement("text", {
  id: 126,
  fontFamily: "IBMPlexMono-Bold, IBM Plex Mono",
  fontSize: 18,
  fontWeight: "bold",
  fill: "#434D7E"
}, React.createElement("tspan", {
  x: 0,
  y: 18
}, "126")), React.createElement("polygon", {
  id: "Triangle",
  fill: "#414B7C",
  transform: "translate(35.500000, 7.250000) scale(-1, -1) translate(-35.500000, -7.250000) ",
  points: "35.5 5.375 38 9.125 33 9.125"
})), React.createElement("text", {
  id: "Local-Copy-2",
  fontFamily: "IBMPlexSans-Text, IBM Plex Sans",
  fontSize: 9,
  fontWeight: 500,
  fill: "#434D7E"
}, React.createElement("tspan", {
  x: 43.2315,
  y: 59
}, "Local")), React.createElement("text", {
  id: "2576-copy-2",
  fontFamily: "IBMPlexSans-Text, IBM Plex Sans",
  fontSize: 9,
  fontWeight: 500,
  fill: "#434D7E"
}, React.createElement("tspan", {
  x: 48.2,
  y: 72
}, "2576")), React.createElement("g", {
  id: "Group-28-Copy-2",
  transform: "translate(36.000000, 65.000000)",
  fill: "#414B7C",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M8.1,0.9 L8.1,6.8265 L7.5735,6.3 L0.9,6.3 L0.9,0.9 L8.1,0.9 L8.1,0.9 Z M8.1,0 L0.9,0 C0.405,0 0,0.405 0,0.9 L0,6.3 C0,6.795 0.405,7.2 0.9,7.2 L7.2,7.2 L9,9 L9,0.9 C9,0.405 8.595,0 8.1,0 L8.1,0 Z",
  id: "XMLID_641_"
}), React.createElement("polygon", {
  id: "XMLID_644_",
  points: "1.5 4.5 1.5 5.25 7.5 5.25 7.5 4.5"
}), React.createElement("polygon", {
  id: "XMLID_642_",
  points: "7.5 3 1.5 3 1.5 3.75 7.5 3.75"
}), React.createElement("polygon", {
  id: "XMLID_642_-Copy",
  points: "7.5 1.5 1.5 1.5 1.5 2.25 7.5 2.25"
}))), React.createElement("path", {
  d: "M96,43 L77.7495751,10 L66,10",
  id: "Path-5-Copy-2",
  strokeOpacity: 0.596976902,
  stroke: "#434D7E",
  strokeLinecap: "round",
  strokeDasharray: "1,3"
}), React.createElement("path", {
  d: "M135,22 L160.695636,45 L172,45",
  id: "Path-6-Copy-6",
  strokeOpacity: 0.596976902,
  stroke: "#434D7E",
  strokeLinecap: "round",
  strokeDasharray: "1,3",
  transform: "translate(153.500000, 33.500000) scale(1, -1) translate(-153.500000, -33.500000) "
}), React.createElement("path", {
  d: "M129,68 L159.11786,106 L171,106",
  id: "Path-6-Copy-7",
  strokeOpacity: 0.596976902,
  stroke: "#434D7E",
  strokeLinecap: "round",
  strokeDasharray: "1,3"
}), React.createElement("path", {
  d: "M68,87 L101.585388,118 L114,118",
  id: "Path-6-Copy-8",
  strokeOpacity: 0.596976902,
  stroke: "#434D7E",
  strokeLinecap: "round",
  strokeDasharray: "1,3",
  transform: "translate(91.000000, 102.500000) scale(-1, 1) translate(-91.000000, -102.500000) "
}));

var SvgExplanation = function SvgExplanation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "221px",
    height: "130px",
    viewBox: "0 0 221 130",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExplanation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/explanation.04c4f387.svg";
export { ForwardRef as ReactComponent };